import { CarouselInsightsItem } from "@/core/components/layout/carousel-insights/components/carousel-insights-item";
import { DashboardPanel, wobaText } from "@/dashboard/components/dashboard-ds";
import { Button } from "@woba/ds-web-next";
import { useEffect, useState } from "react";
import { InsightsCardsConsumptionProps } from "./insights-cards-consumption.types";
function InsightsCardsConsumption({
  tag,
  description,
  content,
  buttonText,
  icon,
  subtitle,
  body,
  type,
  emptyContent,
  onClick,
  hasSubtitleDefaultColor = false,
  carousel = false,
}: InsightsCardsConsumptionProps) {
  const [color, setColor] = useState<{
    background: string;
    text: string;
    subtitle: string;
    iconBackground: string;
    iconText: string;
  } | null>(null);

  const colors = {
    warning: {
      background: "orange-500",
      text: "white",
      subtitle: "sky-600",
      iconBackground: "orange-50",
      iconText: "orange-500",
    },
    danger: {
      background: "destructive",
      text: "white",
      subtitle: hasSubtitleDefaultColor ? "sky-600" : "destructive",
      iconBackground: "red-100",
      iconText: "destructive",
    },
    default: {
      background: "secondary",
      text: "secondary-foreground",
      subtitle: "sky-600",
      iconBackground: "blue-100",
      iconText: "blue-800",
    },
    good: {
      background: "#16A34A",
      text: "white",
      subtitle: "sky-600",
      iconBackground: "success-50",
      iconText: "success-500",
    },
  };

  useEffect(() => {
    const color = colors[type];

    setColor(color);
  }, [type]);

  if (!color) {
    return null;
  }

  return (
    <>
      {carousel ? (
        <CarouselInsightsItem
          icon={icon}
          tag={tag}
          content={content}
          emptyContent={emptyContent}
          buttonText={buttonText}
          color={color}
          onClick={onClick}
        />
      ) : (
        <DashboardPanel
          data-testid="insights-card"
          title={tag}
          description={emptyContent ?? content}
          footer={
            <Button
              appearance="secondary"
              size="small"
              style={{ width: "100%" }}
              label={buttonText}
              onPress={onClick}
            />
          }
        >
          {!emptyContent && subtitle ? (
            <p style={wobaText.captionMedium}>{subtitle}</p>
          ) : null}

          {!emptyContent && body ? body : null}

          {/* O Figma ("Demanda estável") troca o texto longo pelos tiles de
              métrica; nos demais insights o texto continua como apoio. */}
          {!body || emptyContent ? (
            <p style={wobaText.captionMedium}>{description}</p>
          ) : null}
        </DashboardPanel>
      )}
    </>
  );
}

export { InsightsCardsConsumption };
